export function closest (node, tag) {
  var tagar = (tag instanceof Array) ? tag : [tag]
  while (node && node.parentNode) {
    if (tagar.find((n) => {
      if (n.indexOf('.') === -1) {
        return node.nodeName.toLocaleLowerCase() === n.toLocaleLowerCase()
      } else {
        return node.classList !== undefined && node.classList.contains(n.split('.')[1])
      }
    })) {
      return node
    }
    node = node.parentNode
  }
  return null
}

export function selection () {
  if (document.getSelection !== null) {
    return document.getSelection()
  } else {
    return window.getSelection()
  }
}

export function range () {
  let s = selection()
  if (s !== null && s.rangeCount !== 0) {
    return s.getRangeAt(0)
  }
  return document.createRange()
}

export function resetRange (n, noffset, e, eoffset) {
  let s = selection()
  let r
  if (n instanceof Range) {
    r = n
  } else if (noffset === undefined) {
    r = document.createRange()
    if (n !== undefined) {
      r.selectNode(n)
    }
  } else {
    r = document.createRange()
    r.setStart(n, noffset)
  }
  if (e !== undefined && eoffset !== undefined) {
    r.setEnd(e, eoffset)
  }
  s.removeAllRanges()
  s.addRange(r)
}

export function eventRange (e) {
  if (document.caretRangeFromPoint) {
    return document.caretRangeFromPoint(e.clientX, e.clientY)
  } else if (e.rangeParent) {
    let r = document.createRange()
    r.setStart(e.rangeParent, e.rangeOffset)
    return r
  }
}

export function getSibling (target, action) {
  var faname = (action === 'next') ? 'nextSibling' : 'previousSibling'
  var fbname = (action === 'next') ? 'previousSibling' : 'nextSibling'
  var aname = (action === 'next') ? 'next' : 'prev'
  var bname = (action === 'next') ? 'prev' : 'next'
  if (target[faname]) {
    return {target: target[faname], action: aname}
  } else {
    return {target: target[fbname], action: bname}
  }
}

export function getTagElementAction (node, tag, action) {
  var t = closest(node, tag)
  var p = node
  var a = (action === 'next') ? 'nextSibling' : 'previousSibling'
  // console.log(t, p)
  if (t === null) {
    // console.log(p.nodeType, p.parentNode.nodeType)
    while (p.nodeType !== 1) {
      p = p.parentNode
    }
  } else {
    while (t.outerHTML !== p.outerHTML && p[a] === null) {
      p = p.parentNode
    }
  }
  return p
}

export function changeParents (doc, orgtag, curtag, nottag) {
  doc.querySelectorAll(orgtag).forEach((item) => {
    if (!item.parentNode.classList.contains(nottag)) {
      changeParent(item)
    }
  })
}

export function changeParent (node) {
  var p = node.parentNode
  // console.log('changeParent 1', p.outerHTML)
  while (node.firstChild) {
    p.insertBefore(node.firstChild, node)
  }
  // console.log('changeParent 2', p.outerHTML)
  p.removeChild(node)
}

export function changeTag (node, tag) {
  var p = node.parentNode
  var e = document.createElement(tag)
  while (node.firstChild) {
    e.appendChild(node.firstChild)
  }
  console.log('changeTag', p.outerHTML, e.outerHTML, node.outerHTML)
  p.replaceChild(e, node)
  return e
}

export function hasClass (node, cla) {
  for (var f in node.classList) {
    if (cla.indexOf(node.classList[f]) !== -1) {
      return node.classList[f]
    }
  }
}

export class Base64 {
  static _keyStr
  // public method for encoding
  static encode (input) {
    var output = ''
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    input = Base64._utf8encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4)
    }
    return output
  }

  // public method for decoding
  static decode (input) {
    var output = ''
    var chr1, chr2, chr3
    var enc1, enc2, enc3, enc4
    var i = 0
    input = input.replace(/[^A-Za-z0-9+/=]/g, '')
    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++))
      enc2 = this._keyStr.indexOf(input.charAt(i++))
      enc3 = this._keyStr.indexOf(input.charAt(i++))
      enc4 = this._keyStr.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3)
      }
    }
    output = Base64._utf8decode(output)
    return output
  }

  // private method for UTF-8 encoding
  static _utf8encode (string) {
    string = string.replace(/\r\n/g, '\n')
    var utftext = ''
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }

  // private method for UTF-8 decoding
  static _utf8decode (utftext) {
    var string = ''
    var i = 0
    var c = 0
    var c2 = 0
    var c3 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return string
  }
}

export function getTime () {
  var d = new Date()
  return d.getTime()
}

export function isDate (time) {
  // console.log(typeof time)
  if (typeof time === 'number' || typeof time === 'string') {
    return new Date(time)
  }
  return time
}

export function isStep (step, defaultstep) {
  if (step === null || step === undefined) {
    return defaultstep
  }
  return step
}

export function toTime (time) {
  switch (String(time).length) {
    case 1 :
      return '0' + time
    default :
      return time
  }
}

export function timeToDateString (time, step) {
  if (time === undefined) {
    return 'not'
  }
  step = isStep(step, '.')
  time = isDate(time)
  return time.getFullYear() + step + toTime(time.getMonth() + 1) + step + toTime(time.getDate())
}

export function timeToMonthString (time, step) {
  if (time === undefined) {
    return 'not'
  }
  step = isStep(step, '.')
  time = isDate(time)
  return time.getFullYear() + step + toTime(time.getMonth() + 1)
}

export function timeToTimeString (time, step) {
  if (time === undefined) {
    return 'not'
  }
  step = isStep(step, ':')
  time = isDate(time)
  return toTime(time.getHours()) + step + toTime(time.getMinutes()) + step + toTime(time.getSeconds())
}

export function numberToComma (n) {
  if (n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return '0'
  }
}

export function commaToNumber (n) {
  return parseInt(n.replace(/[^\d]+/g, ''))
}

export function minMaxToComma (min, max, n) {
  if (n === '') {
    return numberToComma(min)
  } else if (parseInt(commaToNumber(n)) > max) {
    console.log(numberToComma(max))
    return numberToComma(max)
  } else {
    return numberToComma(commaToNumber(n))
  }
}

export function numberToChange (n) {
  var p = parseInt(n.toString().replace(/[^\d]+/g, ''))
  console.log(p)
  if (p > 10000) {
    p = Math.round(p / 10000)
    console.log(p)
    return numberToComma(p) + '만'
  }
  return numberToComma(p)
}

export function toCount (c) {
  if (c < 1000) {
    return c
  } else if (c < 1000000) {
    return Math.round(c / 100) / 10 + 'K'
  } else if (c < 1000000000) {
    return Math.round(c / 100000) / 10 + 'M'
  } else {
    return Math.round(c / 100000000) / 10 + 'B'
  }
}

export function numberToPhone (n) {
  if (n) {
    n = n.toString().replace(/[^0-9]/g, '')
    if (n.length > 10) {
      return n.replace(/^(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
    } else if (n.length > 6) {
      return n.replace(/^(\d{3})(\d{3})(\d+)/, '$1-$2-$3')
    } else {
      return n.replace(/^(\d{3})(\d+)/, '$1-$2')
    }
  } else {
    return ''
  }
}

export function phoneToNumber (n) {
  return n.toString().replace(/[^0-9]/g, '')
}

export function isEmail (n) {
  return n !== undefined && n.match(/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i) === null
}

export function toSwapString (o, swap, swaps) {
  var ar = o.split(swap)
  return ar.join(swaps)
}

export class Genre {
  static LIFE = 'life'
  static ROMANCE = 'romance'
  static FANTASY = 'fantasy'
  static BOYLOVE = 'boylove'
  static NOVEL = 'novel'

  static getList () {
    return [
      {text: Genre.toString(Genre.NOVEL), key: Genre.NOVEL},
      {text: Genre.toString(Genre.LIFE), key: Genre.LIFE},
      {text: Genre.toString(Genre.ROMANCE), key: Genre.ROMANCE},
      {text: Genre.toString(Genre.FANTASY), key: Genre.FANTASY},
      {text: Genre.toString(Genre.BOYLOVE), key: Genre.BOYLOVE}
    ]
  }

  static getSubgenreList (genre) {
    console.log('getSubgenreList', genre)
    if (genre === -1) {
      return []
    } else {
      var subgenrecount = [6, 4, 4, 10, 3]
      var temp = []
      var i
      for (i = 0; i < subgenrecount[genre]; i++) {
        temp.push({
          text: Genre.subgenreString(Genre.getList()[genre].key, i + 1),
          id: i,
          value: i + 1
        })
      }
      return temp
    }
  }

  static toString (n) {
    switch (n) {
      case this.LIFE :
        return '라이프'
      case this.ROMANCE :
        return '로맨스'
      case this.FANTASY :
        return '판타지<span class="genreStep">ㆍ</span>무협'
      case this.BOYLOVE :
        return 'BL'
      case this.NOVEL :
      default :
        return '일반'
    }
  }

  static tagString (n) {
    switch (n) {
      case this.LIFE :
        return '라이프'
      case this.ROMANCE :
        return '로맨스'
      case this.FANTASY :
        return '판타지'
      case this.BOYLOVE :
        return 'BL'
      case this.NOVEL :
      default :
        return '일반'
    }
  }

  static subgenreString (n, g) {
    switch (n) {
      case this.NOVEL :
        switch (g) {
          case 1 :
            return '인문<span class="genreStep">ㆍ</span>사회<span class="genreStep">ㆍ</span>역사'
          case 2 :
            return '경영<span class="genreStep">ㆍ</span>경제'
          case 3 :
            return '에세이<span class="genreStep">ㆍ</span>시'
          case 4 :
            return '외국어'
          case 5 :
            return '과학'
          case 6 :
            return '컴퓨터<span class="genreStep">ㆍ</span>IT'
          default :
            return ''
        }
      case this.LIFE :
        switch (g) {
          case 1 :
            return '자기개발'
          case 2 :
            return '여행'
          case 3 :
            return '건강<span class="genreStep">ㆍ</span>다이어트'
          case 4 :
            return '가정<span class="genreStep">ㆍ</span>생활'
          default :
            return ''
        }
      case this.ROMANCE :
        switch (g) {
          case 1 :
            return '현대물'
          case 2 :
            return '역사<span class="genreStep">ㆍ</span>시대물'
          case 3 :
            return '판타지물'
          case 4 :
            return 'TL소설'
          default :
            return ''
        }
      case this.FANTASY :
        switch (g) {
          case 1 :
            return '정통 판타지'
          case 2 :
            return '퓨전 판타지'
          case 3 :
            return '현대 판타지'
          case 4 :
            return '게임 판타지'
          case 5 :
            return '정통 무협'
          case 6 :
            return '퓨전 무협'
          case 7 :
            return '현대 무협'
          case 8 :
            return '신 무협'
          case 9 :
            return '대체 역사물'
          case 10 :
            return '스포츠물'
          default :
            return ''
        }
      case this.BOYLOVE :
        switch (g) {
          case 1 :
            return '현대물'
          case 2 :
            return '역사<span class="genreStep">ㆍ</span>시대물'
          case 3 :
            return '판타지물'
          default :
            return ''
        }
      default :
        return ''
    }
  }
}

export class State {
  static VISIBLE = 1
  static MAINOPEN = 2
  static COMMENT = 4
  static SEARCH = 8
  static SHARE = 16
  static ADULT = 32
  static REST = 64
  static DELETE = 128
  static ADMIN = 256
  static COMPLETE = 512
}

export class Menu {
  static VISIBLE = 0
  static MAINOPEN = 1
  static CHANGE_NAME = 2
  static CREATE_POST = 3
  static OPEN_VIEW = 4
  static DELETE = 5
  static DELETE_CANCEL = 6
  static BUY_DELETE = 7
  static READ = 8
  static READ_DELETE = 9
  static LIKE = 10
  static LIKE_DELETE = 11
  static MOVE_WORK = 12
  static MOVE_CATEGORY = 13
  static EDIT = 14
  static REPORT = 15
  static PUBLICATION = 16
  static LATERPOST = 17
  static LATERPOST_DELETE = 18

  static CANCEL = 19
  static COMPLETE = 20
  static RECOMMENT = 21
  static SUBMIT = 22
  static TAX = 23
}

export class Store {
  static NONE = 0
  static RIDIBOOKS = 1
  static NAVER = 2
  static BOOKCUBE = 4
  static KYOBOBOOK = 8
  static YES24 = 16
  static ALADIN = 32
  static ONESTORE = 64

  static toString (n) {
    switch (n) {
      case this.NONE :
        return '신청안함'
      case this.RIDIBOOKS :
        return '리디북스'
      case this.NAVER :
        return '네이버'
      case this.BOOKCUBE :
        return '북큐브'
      case this.KYOBOBOOK :
        return '교보문고'
      case this.YES24 :
        return 'Yes24'
      case this.ALADIN :
        return '알라딘'
      case this.ONESTORE :
        return '원스토어'
      default :
        return '-'
    }
  }

  static getList () {
    return [
      {text: this.toString(this.RIDIBOOKS), value: this.RIDIBOOKS},
      {text: this.toString(this.NAVER), value: this.NAVER},
      {text: this.toString(this.BOOKCUBE), value: this.BOOKCUBE},
      {text: this.toString(this.KYOBOBOOK), value: this.KYOBOBOOK},
      {text: this.toString(this.YES24), value: this.YES24},
      {text: this.toString(this.ALADIN), value: this.ALADIN},
      {text: this.toString(this.ONESTORE), value: this.ONESTORE}
    ]
  }

  static getNone () {
    return {text: this.toString(this.NONE), value: this.NONE}
  }

  static changeState (ar) {
    var s = 0
    ar.forEach((item) => {
      if (item.checked) {
        s += item.value
      }
    })
    return s
  }

  static getStateString (state) {
    var ar = []
    var temp = this.getList()
    temp.forEach(item => {
      console.log(item.value, state)
      if (state & item.value) {
        ar.push(item)
      }
    })
    console.log(ar)
    switch (ar.length) {
      case 0 :
        return ''
      case 1 :
        return ar[0].text
      default :
        return ar[0].text + '외 ' + (ar.length - 1)
    }
  }

  static getListToState (ar) {
    var st = 0
    ar.forEach(item => {
      st += item.bookstore
    })
    return st
  }

  static getMonth (store, year, month) {
    console.log(month)
    if (month === null) {
      return '-'
    }
    switch (store) {
      case this.NONE:
      case -1:
        return '-'
      default:
        return year + '년 ' + (month + 1) + '월'
    }
  }

  static getConfirmDate (ob) {
    switch (ob.bookstore) {
      case this.NONE:
      case -1:
        return '-'
      default:
        console.log(ob.date)
        if (ob.confirm) {
          return timeToDateString(ob.confirm)
        } else {
          return ob.date.split('.')[0] + '년 ' + (Number(ob.date.split('.')[1]) + 1) + '월'
        }
    }
  }

  static getCloseDate (ob) {
    switch (ob.bookstore) {
      case this.NONE:
        return '-'
      default:
        console.log(ob.date)
        if (ob.close) {
          return timeToDateString(ob.close)
        } else {
          return '-'
        }
    }
  }

  static getPublishingDate (ob) {
    console.log('getPublishingDate', ob.confirm)
    if (ob.confirm) {
      return timeToDateString(ob.confirm)
    } else {
      return timeToDateString(ob.date)
    }
  }

  static getPublishingCloseDate (ob) {
    if (ob.close) {
      return timeToDateString(ob.close)
    } else {
      return '-'
    }
  }
}

export class Contract {
  static WAIT = 0
  static COMPLETE = 1
  static USERCANCEL = 2
  static ADMINCANCEL = 3
  static END = 4
  static CANCEL = 5

  static toString (n) {
    switch (n) {
      case this.WAIT :
        return '승인대기'
      case this.COMPLETE :
        return '계약완료'
      case this.USERCANCEL :
        return '신청취소'
      case this.ADMINCANCEL :
        return '승인취소'
      case this.END :
        return '계약종료'
      case this.CANCEL :
        return '계약취소'
      default :
        return '-'
    }
  }
}

export class PublishingBook {
  static WAIT = 0
  static SALE = 1
  static END = 2
  static CANCEL = 3
  static EDIT = 4

  static toString (n) {
    switch (n) {
      case this.WAIT :
        return '승인대기'
      case this.SALE :
        return '판매중'
      case this.END :
        return '판매종료'
      case this.CANCEL :
        return '승인취소'
      case this.EDIT :
        return '수정요청'
      default :
        return '-'
    }
  }
}

export class Bank {
  static WOORIBANK = '020'
  static KBSTAR = '004'
  static IBK = '003'
  static SHINHAN = '088'
  static EPOSTBANK = '071'
  static KBANKNOW = '089'
  static KAKAOBANK = '090'
  static CITIBANK = '027'
  static KEBHANA = '081'
  static STANDARDCHARTERED = '023'
  static KNBANK = '039'
  static KJBANK = '034'
  static DGB = '031'
  static BUSANBANK = '032'
  static JBBANK = '037'
  static EJEJUBANK = '035'
  static NONGHYUP = '011'
  static NFCF = '064'
  static KDB = '002'
  static SUHYUPBANK = '007'
  static KFCC = '045'
  static CU = '048'

  static toString (n) {
    switch (n) {
      case this.WOORIBANK :
        return '우리'
      case this.KBSTAR :
        return '국민'
      case this.IBK :
        return '기업'
      case this.SHINHAN :
        return '신한'
      case this.EPOSTBANK :
        return '우체국'
      case this.KBANKNOW :
        return '케이뱅크'
      case this.KAKAOBANK :
        return '카카오뱅크'
      case this.CITIBANK :
        return '한국씨티은행'
      case this.KEBHANA :
        return 'KEB하나은행'
      case this.STANDARDCHARTERED :
        return 'SC제일은행'
      case this.KNBANK :
        return '경남은행'
      case this.KJBANK :
        return '광주은행'
      case this.DGB :
        return '대구은행'
      case this.BUSANBANK :
        return '부산은행'
      case this.JBBANK :
        return '전북은행'
      case this.EJEJUBANK :
        return '제주은행'
      case this.NONGHYUP :
        return '농협'
      case this.NFCF :
        return '산림조합'
      case this.KDB :
        return '산업'
      case this.SUHYUPBANK :
        return '수협'
      case this.KFCC :
        return '새마을금고'
      case this.CU :
        return '신협'
      default :
        return '-'
    }
  }

  static getList () {
    return [
      {text: this.toString(this.WOORIBANK), value: this.WOORIBANK},
      {text: this.toString(this.KBSTAR), value: this.KBSTAR},
      {text: this.toString(this.IBK), value: this.IBK},
      {text: this.toString(this.SHINHAN), value: this.SHINHAN},
      {text: this.toString(this.EPOSTBANK), value: this.EPOSTBANK},
      {text: this.toString(this.KBANKNOW), value: this.KBANKNOW},
      {text: this.toString(this.KAKAOBANK), value: this.KAKAOBANK},
      {text: this.toString(this.CITIBANK), value: this.CITIBANK},
      {text: this.toString(this.KEBHANA), value: this.KEBHANA},
      {text: this.toString(this.STANDARDCHARTERED), value: this.STANDARDCHARTERED},
      {text: this.toString(this.KNBANK), value: this.KNBANK},
      {text: this.toString(this.KJBANK), value: this.KJBANK},
      {text: this.toString(this.DGB), value: this.DGB},
      {text: this.toString(this.BUSANBANK), value: this.BUSANBANK},
      {text: this.toString(this.JBBANK), value: this.JBBANK},
      {text: this.toString(this.EJEJUBANK), value: this.EJEJUBANK},
      {text: this.toString(this.NONGHYUP), value: this.NONGHYUP},
      {text: this.toString(this.NFCF), value: this.NFCF},
      {text: this.toString(this.KDB), value: this.KDB},
      {text: this.toString(this.SUHYUPBANK), value: this.SUHYUPBANK},
      {text: this.toString(this.KFCC), value: this.KFCC},
      {text: this.toString(this.CU), value: this.CU}
    ]
  }
}

export class Alarm {
  static COMMENT = 1
  static COMMENT_RE = 2
  static SUBSCRIBE = 11
  static LIKE = 12
  static NEWPOST = 13
  static POINT_SUPPORT = 21
  static POINT_BUY = 22
  static POINT_CHANGE_SUBMIT = 23
  static POINT_WITHDRAWAL_CANCEL = 24
  static POINT_CHANGE_CANCEL = 25
  static POINT_SUPPORT_VISIBLE = 26
  static NOTICE = 99

  static SORTTYPE = {
    ALL: 0,
    COMMENT: 1,
    LIKE: 2,
    SUBSCRIBE: 3,
    NEWPOST: 4,
    POINT: 5,
    NOTICE: 99
  }

  static getSortList () {
    return [
      {text: '전체', value: this.SORTTYPE.ALL},
      {text: '댓글', value: this.SORTTYPE.COMMENT},
      {text: '좋아요', value: this.SORTTYPE.LIKE},
      {text: '구독', value: this.SORTTYPE.SUBSCRIBE},
      {text: '새글', value: this.SORTTYPE.NEWPOST},
      {text: '포인트', value: this.SORTTYPE.POINT},
      {text: '공지', value: this.SORTTYPE.NOTICE}
    ]
  }

  static isProfile (item) {
    switch (item.type) {
      case this.COMMENT :
      case this.COMMENT_RE :
      case this.SUBSCRIBE :
      case this.LIKE :
      case this.POINT_SUPPORT :
      case this.POINT_SUPPORT_VISIBLE :
      case this.POINT_BUY :
        return true
      case this.POINT_CHANGE_SUBMIT :
      case this.POINT_WITHDRAWAL_CANCEL :
      case this.POINT_CHANGE_CANCEL :
      case this.NOTICE :
        return false
    }
  }

  static getProfile (item) {
    switch (item.type) {
      case this.COMMENT :
      case this.COMMENT_RE :
      case this.SUBSCRIBE :
      case this.LIKE :
      case this.POINT_SUPPORT :
      case this.POINT_SUPPORT_VISIBLE :
      case this.POINT_BUY :
        return item.targetuser.profile
      case this.POINT_CHANGE_SUBMIT :
      case this.POINT_WITHDRAWAL_CANCEL :
      case this.POINT_CHANGE_CANCEL :
        return '146'
      case this.NOTICE :
        return '160'
    }
  }

  static getAlarmText (item) {
    var color = item.read ? 'guide' : 'title'
    switch (item.type) {
      case this.COMMENT :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 회원님의 글에 댓글을 달았습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.COMMENT_RE :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 댓글에 답글을 달았습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.SUBSCRIBE :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 회원님의 저작공간을 구독합니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.LIKE :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 회원님의 글을 좋아합니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.NEWPOST :
        return '<span class="' + color + '"><b>' + item.work.name + '</b>에 새글이 등록되었습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_SUPPORT :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 회원님의 글에 <b>' + item.point + '</b>포인트를 후원하였습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_SUPPORT_VISIBLE :
        return '<span class="' + color + '">회원님의 글에 <b>' + item.point + '</b>포인트를 후원하였습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_BUY :
        return '<span class="' + color + '"><b>' + item.targetuser.nic + '</b>님이 회원님의 글을 구매하였습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_CHANGE_SUBMIT :
        return '<span class="' + color + '">신청하신 포인트 전환이 완료 되었습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_WITHDRAWAL_CANCEL :
        return '<span class="' + color + '">신청하신 포인트의 출금 신청이 취소되었습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.POINT_CHANGE_CANCEL :
        return '<span class="' + color + '">신청하신 포인트 전환 신청이 취소되었습니다. </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
      case this.NOTICE :
        return '<span class="active">[공지] ' + item.notice + ' </span><span class="guide">' + this.toTimeString(item.date) + '</span>'
    }
  }

  static toTimeString (time) {
    var t = getTime()
    var k = t - time
    k = k / 1000
    var h = 60 * 60
    var d = h * 24
    var w = d * 7
    if (k < 60 * 5) {
      return '방금'
    } else if (k < h) {
      return Math.floor(k / 60) + '분 전'
    } else if (k < d) {
      return Math.floor(k / h) + '시간 전'
    } else if (k < w) {
      return Math.floor(k / d) + '일 전'
    } else if (k < w * 4) {
      return Math.floor(k / w) + '주 전'
    } else {
      return Math.floor(k / w / 4) + '달 전'
    }
  }

  static getAlarmSubText (item) {
    switch (item.type) {
      case this.COMMENT :
      case this.COMMENT_RE :
      case this.LIKE :
      case this.NEWPOST :
      case this.POINT_SUPPORT :
      case this.POINT_BUY :
        return item.post.title
      case this.SUBSCRIBE :
        return item.work.name
      case this.POINT_CHANGE_SUBMIT :
      case this.POINT_WITHDRAWAL_CANCEL :
      case this.POINT_CHANGE_CANCEL :
        return '[확인하기]'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/js/Utils.js